import {adminRoutes} from '@/modules/Admin/Routes/adminRoutes.js'
import {routesByName} from '@/modules/Shared/Helpers/routesHelper.js'

const routes = routesByName(adminRoutes)

export default [
    {
        title: "admin.users.title",
        subtitle: "admin.users.subtitle",
        items: [
            {
                icon: "audiences",
                route: routes['admin-users']
            },
            {
                icon: "acces-point",
                route: routes['admin-roles']
            },
            {
                icon: "capacity",
                route: routes['admin-communities']
            },
            {
                icon: "audiences",
                route: routes['admin-client-users']
            },
            {
                icon: "tracks",
                route: routes['admin-tracks']
            },
            {
                icon: "photos",
                route: routes['admin-photos']
            },
        ]
    },
    {
        title: "admin.apps.title",
        subtitle: "admin.apps.subtitle",
        items: [
            {
                icon: "interstitial_banner",
                route: routes['admin-applications']
            },
            {
                icon: "challenges",
                route: routes['admin-challenges']
            },
            {
                icon: "apple",
                route: routes['admin-apple-accounts']
            },
            {
                icon: "catalogs",
                route: routes['admin-app-conditions']
            },
            {
                icon: "pages",
                route: routes['admin-app-condition-templates']
            },
        ]
    },
    {
        title: "admin.maps.title",
        subtitle: "admin.maps.subtitle",
        items: [
            {
                icon: "participants",
                route: routes['admin-mapbox-accounts']
            },
            {
                icon: "pois",
                route: routes['admin-interactive-maps']
            },
        ]
    },
    {
        title: "dashboard.resorts",
        subtitle: "admin.resorts.subtitle",
        items: [
            {
                icon: "pois",
                route: routes['admin-resorts']
            }
        ]
    },
    {
        title: "admin.platform.title",
        subtitle: "admin.platform.subtitle",
        items: [
            {
                icon: "content",
                route: routes['admin-translations']
            },
            {
                icon: "pushmessages",
                route: routes['admin-push-delivery-kpis']
            },
            {
                icon: "acces-point",
                route: routes['admin-shared-credentials']
            }
        ]
    },
]
